import { render, staticRenderFns } from "./customSubFormWidget.vue?vue&type=template&id=04a6e41d&scoped=true"
import script from "./customSubFormWidget.vue?vue&type=script&lang=js"
export * from "./customSubFormWidget.vue?vue&type=script&lang=js"
import style0 from "./customSubFormWidget.vue?vue&type=style&index=0&id=04a6e41d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a6e41d",
  null
  
)

export default component.exports